(() => {
  if (window.__sqDesktopGallery) return;
  window.__sqDesktopGallery = true;
  const desktop = matchMedia('(min-width: 750px)');
  const galleries = new Set();
  let frame;
  function measure() {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      const header = document.querySelector('.section-header');
      const clearance = (header?.getBoundingClientRect().height || 0) + 16;
      for (const gallery of galleries) {
        if (!gallery.isConnected) {
          observer.unobserve(gallery);
          galleries.delete(gallery);
          continue;
        }
        if (!desktop.matches) {
          gallery.style.removeProperty('--sq-gallery-top');
          continue;
        }
        const height = gallery.getBoundingClientRect().height;
        // Tall galleries scroll naturally until their bottom can stay in view.
        gallery.style.setProperty('--sq-gallery-top', `${Math.min(clearance, innerHeight - height - 16)}px`);
      }
    });
  }
  const observer = new ResizeObserver(measure);
  function connect() {
    document.querySelectorAll('product-info .product--left > .product__media-wrapper > media-gallery').forEach(gallery => {
      if (!galleries.has(gallery)) {
        galleries.add(gallery);
        observer.observe(gallery);
      }
    });
    const header = document.querySelector('.section-header');
    if (header) observer.observe(header);
    measure();
  }
  connect();
  addEventListener('resize', measure, { passive: true });
  desktop.addEventListener('change', measure);
  document.addEventListener('shopify:section:load', connect);
  document.addEventListener('shopify:section:unload', measure);
})();
